<div>
  <app-table-header title="Patient List" [showAddButton]="true" buttonText="Assign New Patient"
    (onAddClick)="openAssignPatientModal()"></app-table-header>
  <p-table [value]="patients" [rows]="APP_CONFIG.dataTable.rows" [lazy]="true" (onLazyLoad)="loadPatients($event)"
    [totalRecords]="totalRecords" [showCurrentPageReport]="true" sortField="lastInrValue" [sortOrder]="-1"
    [rowsPerPageOptions]="APP_CONFIG.dataTable.rowsPerPageOptions" [loading]="loading" [paginator]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" responsiveLayout="scroll">
    <ng-template pTemplate="header">
      <!--   ****************** Headers row **********************************    -->
      <tr class="table-row">
        <th *ngFor="let col of columns" pSortableColumn="{{col?.field}}" [style]="col?.style">{{col?.title}}
          <p-sortIcon field="{{col?.field}}"></p-sortIcon>
        </th>
      </tr>

      <!--   ****************** Filters row **********************************    -->
      <tr>
        <th *ngFor="let col of columns">
          <ng-container *ngIf="col?.filter?.type == 'dropdown'">
            <p-columnFilter field="{{col?.field}}" matchMode="equals" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-dropdown [ngModel]="value" appendTo="body" [options]="col?.filter?.options!"
                  (onChange)="filter($event.value)" placeholder="{{col?.title}}" [showClear]="true">
                  <ng-template let-option pTemplate="item">
                    <span>{{option.label}}</span>
                  </ng-template>
                </p-dropdown>

              </ng-template>
            </p-columnFilter>
          </ng-container>
          <ng-container *ngIf="col?.filter?.type == 'date'">
            <p-columnFilter field="{{col?.field}}" matchMode="equals" [showMenu]="false">
              <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                <p-calendar [ngModel]="value" appendTo="body" (onSelect)="filter($event)" dateFormat="yy-mm-dd"
                  dataType="string" placeholder="{{col?.title}}" [showClear]="true" [showIcon]="true"
                  styleClass="inr-date-filter" [inputStyle]="{'width': '100%'}" [style]="{'width': '100%'}"
                  (onClear)="filter(null)"></p-calendar>
              </ng-template>
            </p-columnFilter>
          </ng-container>
          <ng-container *ngIf="col?.filter?.type == 'numeric'|| col?.filter?.type == 'text'">
            <p-columnFilter type="{{col?.filter?.type}}" field="{{col?.field}}" [showMenu]="false" [showButtons]="false"
              placeholder="Search by {{col?.title}}"></p-columnFilter>
          </ng-container>
        </th>
      </tr>
    </ng-template>
    <!--   ****************** Body rows **********************************    -->
    <ng-template pTemplate="body" let-dataRow>
      <tr routerLink="/inr/patients-list/{{ dataRow.id }}" class="table-row">
        <td style="text-align: left !important">{{ dataRow.mrn }}</td>
        <td style="color: #47A9E4; font-weight: 500; text-align: left !important">{{ dataRow.fullName }}</td>
        <td style="text-align: left !important">{{ dataRow.nationalId }}</td>
        <td style="text-align: left !important">{{ dataRow.lastTestDate | date : "yyyy-MM-dd" }}</td>
        <td
          [style.color]="(dataRow.lastInrValue >= dataRow.targetInrFrom && dataRow.lastInrValue <= dataRow.targetInrTo) ? '#22c55e' : '#ef4444'"
          style="font-weight: 500;">{{ dataRow.lastInrValue }}</td>
        <td>{{ dataRow.initialMarivanDose }} mg</td>
        <td>
          <div style="display: flex; align-items: center; justify-content: center;">
            <span style="width: 10px; height: 10px; border-radius: 50%; margin-right: 8px;"
              [style.background-color]="dataRow.isActive ? '#28a745' : '#6c757d'"></span>
            {{ dataRow.isActive ? 'Active' : 'Inactive' }}
          </div>
        </td>
        <td>
          <div style="display: flex; align-items: center; justify-content: center;">
            <span style="width: 10px; height: 10px; border-radius: 50%; margin-right: 8px;"
              [style.background-color]="dataRow.isResponded ? '#28a745' : '#ffc107'"></span>
            {{ dataRow.isResponded ? 'Responded' : 'Pending' }}
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td class="text-center text-black-50" [attr.colspan]="columns.length!">No data found.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<app-assign-patient-to-inr-modal [(display)]="showAssignPatientModal"
  (onPatientAssigned)="refreshList()"></app-assign-patient-to-inr-modal>